module.exports = __webpack_public_path__ + "img/arrowPress.341bce01.svg";